import React from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Suppresses non-fatal PayPal SDK "zoid destroyed" errors on unmount/navigation.
class PayPalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch() {}
  render() {
    if (this.state.hasError) {
      return (
        <p className="text-sm text-white/50 text-center py-3">
          PayPal is temporarily unavailable — please use card checkout above.
        </p>
      );
    }
    return this.props.children;
  }
}

export const PayPalCheckout = ({ productId, color, strength, quantity, email, phone, code, onSuccess }) => {
  return (
    <div className="mt-4 rounded-xl overflow-hidden" data-testid={`paypal-${productId}`}>
      <PayPalErrorBoundary>
        <PayPalButtons
          style={{ layout: "horizontal", color: "gold", shape: "pill", height: 48, tagline: false, label: "paypal" }}
          forceReRender={[productId, color, strength, quantity, email, phone, code]}
          createOrder={async () => {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || "")) {
              toast.error("Please enter a valid email for your receipt.");
              throw new Error("invalid email");
            }
            try {
              const res = await axios.post(`${API}/paypal/create-order`, {
                product_id: productId, color, strength, quantity, email, phone: phone || null, code: code || null,
              });
              return res.data.id;
            } catch (e) {
              toast.error("Could not start PayPal checkout.");
              throw e;
            }
          }}
          onApprove={async (data) => {
            try {
              const res = await axios.post(`${API}/paypal/capture-order`, { order_id: data.orderID });
              if (res.data.paid) {
                onSuccess?.();
              } else {
                toast.error("PayPal payment was not completed.");
              }
            } catch (e) {
              toast.error("There was a problem confirming your PayPal payment.");
            }
          }}
          onError={() => toast.error("PayPal encountered an error. Please try again.")}
        />
      </PayPalErrorBoundary>
    </div>
  );
};
